module.exports = __webpack_public_path__ + "static/media/Colette King Bed Base - 180x210 cm.5cd2fa3f.jpg";